module.exports = __webpack_public_path__ + "static/media/logo-mirador.302253ee.png";